import React, { ReactNode } from 'react';
import { Info, AlertCircle, CheckCircle, XCircle } from 'lucide-react';
type HelperVariant = 'info' | 'warning' | 'success' | 'error';
interface HelperBlockProps {
  variant?: HelperVariant;
  icon?: React.ComponentType<{
    className?: string;
  }>;
  children: ReactNode;
  className?: string;
}
export function HelperBlock({
  variant = 'info',
  icon,
  children,
  className = ''
}: HelperBlockProps) {
  const variantStyles = {
    info: 'bg-aliceBlue border-borderColor text-secondary',
    warning: 'bg-amber-50 border-amber-200 text-amber-800',
    success: 'bg-turquoise/10 border-turquoise/30 text-primary',
    error: 'bg-red-50 border-red-200 text-destructive'
  };
  const iconStyles = {
    info: 'text-violetBlue',
    warning: 'text-amber-700',
    success: 'text-turquoise',
    error: 'text-destructive'
  };
  const defaultIcons = {
    info: Info,
    warning: AlertCircle,
    success: CheckCircle,
    error: XCircle
  };
  const Icon = icon || defaultIcons[variant];
  return <div className={`p-3 sm:p-4 rounded-lg sm:rounded-xl border flex items-start gap-2 sm:gap-3 ${variantStyles[variant]} ${className}`} data-id="element-981">
      <Icon className={`w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0 mt-0.5 ${iconStyles[variant]}`} data-id="element-982" />
      <div className="text-xs sm:text-sm leading-relaxed" data-id="element-983">{children}</div>
    </div>;
}